"use strict";

exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};


//////////////////
// WEBPACK FOOTER
// ./src/frontend-lib/~/babel-runtime/helpers/classCallCheck.js
// module id = YCm2
// module chunks = 0